import React from 'react';
import { Typography, IconButton } from '@material-ui/core';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { FieldValues } from '../IMSFormFieldsTypes';

interface Component {
  id: React.Key | null | undefined;
  control_type: string;
  component_form?: any[];
  helper_text?: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactPortal | null | undefined;
  is_auto_populated?: boolean;
  component_response?: any;
  label_display?: any;
  label?: any;
}

interface IMSFormAccordionFieldWrapperProps {
  component: Component;
  fieldValues: FieldValues;
  shouldShowAutoPopulatedIndicator: (component: any, fieldValues: FieldValues) => boolean;
  children: React.ReactNode;
}

const AutoPopulateIndicator = () => (
  <FiberManualRecordIcon
    sx={{
      position: 'absolute',
      left: -30,
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#209b2e',
      fontSize: '20px',
    }}
    titleAccess="Auto-populated from VIN"
  />
);

const IMSFormAccordionFieldWrapper: React.FC<IMSFormAccordionFieldWrapperProps> = ({
  component,
  fieldValues,
  shouldShowAutoPopulatedIndicator,
  children,
}) => {
  const showAutoPopulated = typeof component.id === 'number' && shouldShowAutoPopulatedIndicator(component, fieldValues);
  const needsLabelRendered = !['textfield', 'checkboxgroup', 'heading', 'subheading'].includes(component.control_type);

  return (
    <div
      style={{
        marginBottom: '25px',
        width: '100%',
        marginLeft: '20px',
        position: 'relative',
      }}
    >
      {needsLabelRendered && (
        <label style={{ marginBottom: '12px' }}>
          {component.label_display || component.label}
        </label>
      )}

      <div style={{ position: 'relative', width: '100%' }}>
        {children}
        {showAutoPopulated && <AutoPopulateIndicator />}
      </div>

      {component.component_form && component.component_form.length > 0 && (
        <IconButton
          aria-label="Help"
          size="small"
          style={{ marginLeft: '5px', verticalAlign: 'middle' }}
          onClick={() => {
            window.open(component.component_form?.[0]?.help_link, '_blank');
          }}
        >
          <OpenInNewIcon style={{ fontSize: '15px', color: '#4f2682' }} />
        </IconButton>
      )}

      {component.helper_text && (
        <div style={{ width: '70%' }}>
          <Typography
            variant="caption"
            style={{
              fontSize: 'small',
              color: '#666',
            }}
          >
            {component.helper_text}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default IMSFormAccordionFieldWrapper;
